import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import v3Image from "../../assets/DoorAccess/door-hub.jpg";
import image from "../../assets/product-list-assets/cameras/door-access/door-hub.jpg";
import type { Product } from "../../types";
import { controlHubs } from "../product-list-groups/controlHubs";
import {
  accessPowerMethod,
  inputTerminals,
  outputRelays,
  poePorts,
  powerRedundancy,
} from "../properties";

export const doorHub: Product = {
  id: "doorHub",
  productTitle: "Door Hub",
  description: "doorHub.description",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.DoorAccess}/ua-hub-door`,
  ],
  storePathParts: {
    category: UniFiChildCategorySlug.DoorAccessHub,
    productSlug: "ua-hub-door",
  },
  productListGroup: controlHubs,
  image: { src: image, width: 200, height: 160 },
  v3Image: {
    src: v3Image,
    width: 266,
    height: 182,
  },
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '174.9 x 126 x 32.9 mm\n(6.9 x 5 x 1.3")',
      },
    },
    {
      propertyId: outputRelays.id,
      value: {
        type: "translation",
        value: "doorHub.outputRelays",
      },
    },
    {
      propertyId: inputTerminals.id,
      value: {
        type: "translation",
        value: "doorHub.inputTerminals",
      },
    },
    {
      propertyId: poePorts.id,
      value: {
        type: "translation",
        value: "doorHub.poePorts",
      },
    },
    {
      propertyId: accessPowerMethod.id,
      value: { type: "string", value: "PoE++" },
    },
    {
      propertyId: powerRedundancy.id,
      value: { type: "boolean", value: false },
    },
  ],
};
